module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('span', {
    staticClass: "label",
    class: [_vm.seType]
  }, [_vm._t("default"), _vm._v(" "), (!!_vm.close) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', [_vm._v("×")])]) : _vm._e()], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-ded52eb8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/label.vue
// module id = 338
// module chunks = 2